import { render } from "./EditableTable.vue?vue&type=template&id=62c786f1&scoped=true"
import script from "./EditableTable.vue?vue&type=script&lang=js"
export * from "./EditableTable.vue?vue&type=script&lang=js"

import "./EditableTable.vue?vue&type=style&index=0&id=62c786f1&scoped=true&lang=css"

import exportComponent from "/Users/rosswilliams/aqfer-workspace/cx-portal2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62c786f1"]])

export default __exports__